import { apiClient } from './apiClient';
import type { CommissionStatus } from '../types/commission';

// SW-98: read-only commission status + the "request a preferential
// agreement" lead flow.
export const commissionService = {
  async getStatus(token: string): Promise<CommissionStatus> {
    return apiClient.get<CommissionStatus>('/business-profile/commission-status', token);
  },

  async requestAgreement(token: string): Promise<CommissionStatus> {
    return apiClient.post<CommissionStatus>('/business-profile/commission/request', undefined, token);
  },
};
